import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Constants } from "../../../constants";
import ThemeService from "../services/theme.service";
import { ArcusAuthService } from "../../core/arcusauth.service";
import { ActivatedRoute } from "@angular/router";
import { MatMiniFabButton, MatButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { MatCard, MatCardContent } from "@angular/material/card";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
    selector: "login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    imports: [MatMiniFabButton, MatTooltip, MatIcon, MatCard, MatCardContent, MatButton, FaIconComponent],
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup = new FormGroup({
        userName: new FormControl<string>(null, [Validators.required, Validators.pattern(Constants.emailRegEx)]),
        password: new FormControl<string>(null, Validators.required),
    });
    loginFailed: boolean = false;
    userProfile: object;

    constructor(
        public authService: ArcusAuthService,
        public themeService: ThemeService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            if (params["redirected"] === "true") {
                this.login();
            } else if (params["customer"] === "true") {
                this.customerLogin();
            }
        });
    }

    themeToggle() {
        this.themeService.toggleTheme();
    }

    onKeyDown(e) {
        if (e.key == "Enter") this.login();
    }

    login() {
        this.authService.login();
    }

    customerLogin() {
        this.authService.login("", "customer");
    }
}
